import { Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions } from 'ag-grid-community';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { Service } from '../service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from "xlsx";
import { ediorderpriority } from '../common/models/ediorderpriority';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ediorderpriorityList } from '../common/models/ediorderpriorityList';
import { sparePartsList } from '../common/models/sparePartsList';
import { spareParts } from '../common/models/spareparts';
import { cpib2GatewaySpareParts } from '../common/models/Cpib2GatewaySpareParts';
import { epalGatewaySpareParts } from '../common/models/epalGatewaySpareParts';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { epalDeviceSpareParts } from '../common/models/epalDeviceSpareParts';
import { ediorder } from '../common/models/ediOrder';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { MasterDataService } from '../services/master-data.service';

@Component({
    selector: 'app-ediorders',
    templateUrl: './ediorders.component.html',
    styleUrls: ['./ediorders.component.scss'],
    standalone: false
})
export class EdiordersComponent implements OnInit {
  title = 'EDI Order Search';
  @ViewChild("agGridEdiOrders", { static: false }) agGridGateway!: AgGridAngular;
  @ViewChild("agPGridEdiOrders", { static: false }) agPGridEdiOrders!: AgGridAngular;
  @ViewChild("agSPGrid", { static: false }) agSPGrid!: AgGridAngular;
  @ViewChild('tabGroup', { static: false }) tabGroup!: MatTabGroup;

  rowData: any[];
  columnDefs: any[];
  UpdatePriorityRowData: ediorderpriority[]
  PriorityRowData: ediorderpriorityList[];
  PriorityLoadData: ediorderpriorityList[];
  sparePartsLoadData: sparePartsList[];
  filteredSparePartsLoadData: sparePartsList[];
  columnPDefs: any[];
  columnSPDefs: any[];
  fileTypes: any[];
  txtEdiOrdersPOSrch: any;
  txtEdiOrdersUNSrch: any;
  txtEdiOrdersONSrch: any;
  gridOptions: GridOptions;
  priorityGridOptions: GridOptions;
  sparePartsGridOptions: GridOptions;
  createdFromDate: Date;
  closeResult: string;
  fileToUpload: File;
  excelUnitTypeError: string = "";
  txtPriEdiOrdersSrch: any;
  matTabs = [1, 2, 3, 4];
  lblEdiOrderCount: number = 0;
  txtSparePartsSrch: string = "";
  isRowSelected: boolean;
  rowSelectedData: {};
  selectedSPartsInfo = [];
  gatewayUpdateEnable: boolean;
  gatewaySimCardEnable: boolean;
  ePALgatewayUpdateEnable: boolean;
  ePALgatewaySimCardEnable: boolean;
  ePALDeviceEnable: boolean;
  unitNumber: string;
  shipperName: string;
  buildingAddress: string;
  gatewayTypeSelectedValue: string = "DIGI-EX12";
  txtGWMlMacAdd: string = "002704";
  txtGWMlIccId: string = "";
  txtGWMlIccId2: string;
  txtGWPwd: string;
  gatewayTypes: any[];
  lblErrorGWMLMacAdd = "";
  lblErrorGWMLType = "";
  gatewayTypeSelectedId: number;
  Devicegateway: any[];
  devicegatewayTypeSelValue: string;
  devicegatewayTypeSelId: number = 2;
  txtEGWMlMacAdd: string = "002704";
  txtEGWPwd: string;
  txtEGWMlIccId: string = "";
  txtEGWMlIccId2: string = "";
  eGatewayTypeSelectedValue: string;
  eGatewayTypeSelectedId: number;
  lblErrorEGWMLMacAdd = "";
  lblErrorGSimCard = "";
  lblErrorEGSimCard = "";
  lblErrorEUUID = "";
  lblErrorESerialNumber = "";
  lblErrorDevAppType = "";
  poNumber: string;
  branch: string;
  orderNumber: string;
  sparePartsInfo = new spareParts();
  cpib2GatewaySparePartsdetails = new cpib2GatewaySpareParts;
  epalGatewaySparePartsdetails = new epalGatewaySpareParts;
  epalDeviceSparePartsdetails = new epalDeviceSpareParts;
  enableDisableSavebtn: boolean = true;
  txtePalUUID: string;
  txteSerailNumber: string = "";
  appContentSelectedValue: string;
  appContent: any[];
  appContentError: string = "";
  appContentSelectedId: number = 0;
  addPONumber: string;
  addBranch: string;
  addOrderNumber: string;
  txtBranch: string;
  txtShipperName: string = "";
  txtShipperPhone: string = "";
  txtBuildingAddress: string = "";
  txtUnitNumber: string = "";
  txtJobSite: string = "";
  txtNotes: string = "";
  partNumbers: any[];
  partNumberSelectedId: number;
  partNumberSelectedValue: any;
  lblErrorBranch = "";
  lblErrorShipperName = "";
  lblErrorShipperPhone = "";
  lblErrorUnitNumber = "";
  lblErrorPartNumber = "";
  ediOrder = {} as ediorder;
  userDetails: any;
  enableEDIOrder: boolean = false;

  constructor(private apiService: Service, private toastr: FCToasterService, private modalService: NgbModal,
    private oauthService: OAuthService, private router: Router, private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    this.getLoggedInUserDetails();
    this.bindGridOnPageLoad();
    this.getSparePartsGridDataOnSearch();
    this.getGatewayTypes();
    this.getDeviceGatewayTypes();
    this.getEloViewAppContent();
    this.gridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32
    }

    this.priorityGridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32
    }

    this.sparePartsGridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32
    }
    this.bindDefaultValuesOnPageLoad();
  }

  //Grid Data bind in EDI Orders page Load
  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "PO Number", field: "poNumber", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "purchaseOrderNumber", headerTooltip: "PO Number" },
      { headerName: "Contract", field: "contract", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "contract", headerTooltip: "Contract" },
      { headerName: "Branch", field: "branch", sortable: true, minWidth: 160, flex: 1.6, tooltipField: "branch", headerTooltip: "Branch" },
      { headerName: "Order Number", field: "orderNumber", sortable: true, minWidth: 200, flex: 2, tooltipField: "orderNumber", headerTooltip: "Order Number" },
      { headerName: "Unit Number", field: "unitNumber", sortable: true, minWidth: 150, flex: 1.5, tooltipField: "unitNumber", headerTooltip: "Unit Number" },
      { headerName: "PO Date", field: "poDate", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "poDate", headerTooltip: "PO Date" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "Shipper Name", field: "shipperName", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "shipperName", headerTooltip: "Shipper Name" },
      { headerName: "Shipper Phone", field: "shipperPhone", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "shipperPhone", headerTooltip: "Shipper Phone" },
      { headerName: "Part Number", field: "partNumber", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "partNumber", headerTooltip: "Part Number" },
      { headerName: "Qty", field: "quantity", sortable: true, minWidth: 140, flex: 1.4, tooltipField: "quantity", headerTooltip: "Qty" },
      { headerName: "Price", field: "price", sortable: true, minWidth: 150, flex: 1.5, tooltipField: "price", headerTooltip: "Price" },
      { headerName: "Unit Status", field: "unitStatus", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "unitStatus", headerTooltip: "Unit Status" },
      { headerName: "JobSite", field: "jobSite", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "jobSite", headerTooltip: "JobSite" }
    ];
    this.rowData = [];

    this.columnPDefs = [
      { headerName: "Priority", field: "priority", sortable: true, width: 130, cellEditor: "agTextCellEditor", editable: true },
      { headerName: "PO", field: "poNumber", sortable: true, width: 180, tooltipField: "poNumber", headerTooltip: "PO Number" },
      { headerName: "Order #", field: "orderNumber", sortable: true, width: 130, tooltipField: "orderNumber", headerTooltip: "Order" },
      { headerName: "Machine", field: "machine", sortable: true, width: 130, resizable: true, tooltipField: "machine", headerTooltip: "Machine" },
      { headerName: "Need By", field: "needBy", sortable: true, width: 180, tooltipField: "needBy", headerTooltip: "Need By" },
      { headerName: "BI Data State", field: "biDataState", sortable: true, width: 160, tooltipField: "biDataState", headerTooltip: "BI Data State" },
      { headerName: "G3MS State", field: "g3MSState", sortable: true, width: 150, tooltipField: "g3MSState", headerTooltip: "G3MS State" },
      { headerName: "Rel", field: "rel", sortable: true, width: 100, tooltipField: "rel", headerTooltip: "" },
      { headerName: "Altek Reference", field: "altekRef", sortable: true, width: 200, tooltipField: "altekRef", headerTooltip: "Altek Reference" },
      { headerName: "Type", field: "type", sortable: true, width: 100, tooltipField: "type", headerTooltip: "Type" },
      { headerName: "GL ID", field: "glid", sortable: true, width: 110, tooltipField: "glid", headerTooltip: "GL ID" },
      { headerName: "Req. Machines", field: "reqMachines", sortable: true, width: 170, tooltipField: "reqMachines", headerTooltip: "Required Machines" },
      { headerName: "Found Machines", field: "foundMachines", sortable: true, width: 190, tooltipField: "foundMachines", headerTooltip: "Found Machines" },
      { headerName: "PriorityHidden", field: "priorityHidden", sortable: true, width: 130, hide: true, exporterSuppressExport: true }

    ];

    this.columnSPDefs = [
      { headerName: "", field: "cbox", filter: false, sortable: false, checkboxSelection: true, width: 50 },
      { headerName: "Branch", field: "branch", sortable: true, width: 120, tooltipField: "branch", headerTooltip: "Branch" },
      { headerName: "PO", field: "poNumber", sortable: true, width: 180, tooltipField: "poNumber", headerTooltip: "PO Number" },
      { headerName: "Order #", field: "orderNumber", sortable: true, width: 130, tooltipField: "orderNumber", headerTooltip: "Order" },
      { headerName: "Unit Number", field: "unitNumber", sortable: true, width: 160, resizable: true, tooltipField: "unitNumber", headerTooltip: "Unit Number" },
      { headerName: "Shipper Name", field: "shipperName", sortable: true, width: 180, tooltipField: "shipperName", headerTooltip: "Shipper Name" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, width: 260, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "Gateway Type", field: "gatewayType", sortable: true, width: 180, tooltipField: "GatewayType", headerTooltip: "Gateway Type" },
      { headerName: "Gateway Mac Address", field: "gatewayMacAddress", sortable: true, width: 240, tooltipField: "gatewayMacAddress", headerTooltip: "Gateway Mac Address" },
      { headerName: "Gateway Simcard ICCID", field: "gatewaySimCardICCID1", sortable: true, width: 250, tooltipField: "gatewaySimCardICCID1", headerTooltip: "Gateway Simcard ICCID" },
      { headerName: "Gateway Simcard ICCID 2", field: "gatewaySimCardICCID2", sortable: true, width: 250, tooltipField: "gatewaySimCardICCID2", headerTooltip: "Gateway Simcard ICCID 2" },
      { headerName: "Device Gateway Type", field: "deviceGatewayType", sortable: true, width: 200, tooltipField: "deviceGatewayType", headerTooltip: "Device Gateway Type" },
      { headerName: "ePAL Gateway Type", field: "epalGatewayType", sortable: true, width: 200, tooltipField: "ePALGatewayType", headerTooltip: "ePAL Gateway Type" },
      { headerName: "ePAL Gateway Mac Address", field: "epalGatewayMacAddress", sortable: true, width: 260, tooltipField: "epalGatewayMacAddress", headerTooltip: "ePAL Gateway Mac Address" },
      { headerName: "ePAL Gateway Simcard ICCID", field: "epalGatewaySimCardICCID1", sortable: true, width: 280, tooltipField: "epalGatewaySimCardICCID1", headerTooltip: "ePAL Gateway Simcard ICCID" },
      { headerName: "ePAL Gateway Simcard ICCID 2", field: "epalGatewaySimCardICCID2", sortable: true, width: 285, tooltipField: "epalGatewaySimCardICCID2", headerTooltip: "ePAL Gateway Simcard ICCID 2" },
      { headerName: "Eloview Serial Number", field: "eloViewSerialNumber", sortable: true, width: 260, tooltipField: "eloViewSerialNumber", headerTooltip: "Eloview Serial Number" },
      { headerName: "ePAL HardwareId", field: "epalHardwareID", sortable: true, width: 250, tooltipField: "epalHardwareID", headerTooltip: "ePAL HardwareId" },
      { headerName: "Device Application Type", field: "deviceApplicationType", sortable: true, width: 285, tooltipField: "deviceApplicationType", headerTooltip: "Device Application Type" },
    ];
  }

  // Assign default values to variables on Page load
  bindDefaultValuesOnPageLoad() {
    this.txtEdiOrdersPOSrch = "";
    this.txtEdiOrdersUNSrch = "";
    this.txtEdiOrdersONSrch = "";
    this.txtPriEdiOrdersSrch = "";
    this.appContentError = "";
    this.rowData = [];  
    this.userDetails = ""; 
    this.enableEDIOrder = false;
    this.getGridDataOnLoad();
    this.getPriorityGridDataOnSearch();
  }

  onKeyEnter() {
    this.getGridDataOnSearch();
  }

  //Get the EDI Order data on load
  getGridDataOnLoad() {
    this.apiService
      .getEDIOrdersData(this.txtEdiOrdersPOSrch, this.txtEdiOrdersUNSrch, this.txtEdiOrdersONSrch)
      .subscribe((data: any) => {
        if (data != null) {
          this.rowData = data;
        }
        else {
          this.rowData = [];
        }
      });
  }

  //Get the EDI Order data on search
  getGridDataOnSearch() {
    if (this.txtEdiOrdersPOSrch.trim() === "" && this.txtEdiOrdersUNSrch.trim() === "" && this.txtEdiOrdersONSrch.trim() === "") {
      this.toastr.showError("Please enter PO Number or Unit Number or Order Number");
      this.rowData = [];
    }
    var i = 0;
    if (this.txtEdiOrdersPOSrch.trim() !== "") {
      i++;
    }
    if (this.txtEdiOrdersUNSrch.trim() !== "") {
      i++;
    }
    if (this.txtEdiOrdersONSrch.trim() !== "") {
      i++;
    }
    if (i > 1) {
      this.toastr.showError("Please enter either PO Number or Unit Number or Order Number");
      this.rowData = [];
    }
    else {
      this.apiService
        .getEDIOrdersData(this.txtEdiOrdersPOSrch, this.txtEdiOrdersUNSrch, this.txtEdiOrdersONSrch)
        .subscribe((data: any) => {
          if (data != null) {
            this.rowData = data;
          }
          else {
            this.rowData = [];
          }
        });
    }
  }

  //Reset filters
  resetFilters() {
    this.bindDefaultValuesOnPageLoad();
    this.bindGridOnPageLoad();
  }

  onChange(event: MatTabChangeEvent) {
    this.tabGroup._tabs.toArray()[3].disabled = true;
    const tab = event.tab.textLabel;
    if (tab === "EDI Orders Search") {
      this.tabGroup._tabs.toArray()[0].disabled = true;
      this.tabGroup._tabs.toArray()[1].disabled = false;
      this.tabGroup._tabs.toArray()[2].disabled = false;
    }
    else if (tab === "EDI Orders Priority") {
      this.tabGroup._tabs.toArray()[0].disabled = false;
      this.tabGroup._tabs.toArray()[1].disabled = true;
      this.tabGroup._tabs.toArray()[2].disabled = false;
    }
    else {
      this.tabGroup._tabs.toArray()[0].disabled = false;
      this.tabGroup._tabs.toArray()[1].disabled = false;
      this.tabGroup._tabs.toArray()[2].disabled = true;      
    }
    this.resetFilters();
    this.resetPFilters();
    this.resetSPFilters();
  }

  getPriorityGridDataOnSearch() {
    this.apiService
      .getEDIOrdersPrirorityData()
      .subscribe((data: ediorderpriorityList[]) => {
        if (data != null) {
          this.PriorityLoadData = data;
          this.PriorityRowData = this.PriorityLoadData;
          this.lblEdiOrderCount = this.PriorityLoadData.length;
          this.agPGridEdiOrders?.api?.setFilterModel(null);
        }
        else {
          this.PriorityLoadData = [];
        }
      });
  }

  onFileUpload() {
    if (this.fileToUpload !== null && this.fileToUpload !== undefined) {
      if (this.onFileUploadValidations()) {
        const reader: FileReader = new FileReader();
        reader.readAsArrayBuffer(this.fileToUpload);
        reader.onload = (e: any) => {
          const bstr: string = e.target.result;
          const ediWorkBook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
          if (ediWorkBook.SheetNames.length < 3) {
            this.toastr.showError("Please upload a valid file");
            return;
          }
          const biWSName = ediWorkBook.SheetNames[2];
          if (biWSName !== undefined && biWSName.toUpperCase() === "GL STATUS REPORT") {
            this.apiService.uploadEDIPriorityFile(this.fileToUpload).subscribe((data: number) => {
              if (data > 0) {
                this.modalService.dismissAll();
                this.clearModalPopupClose();
                this.getPriorityGridDataOnSearch();
                this.toastr.showSuccess("Successfully Uploaded!!");
              }
              else {
                this.toastr.showError("Failed to upload the file");
                this.modalService.dismissAll();
              }
            });
          }
          else {
            this.toastr.showError("Sheet Name should be GL Status Report in the selected file");
          }
        }
      }
    }
    else {
      this.excelUnitTypeError = "Please select a file to upload"
    }
  }

  clearModalPopupClose() {
    this.excelUnitTypeError = "";
  }

  onFileUploadValidations(): boolean {
    if (this.fileToUpload["type"] != ("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      this.excelUnitTypeError = "Please select only Excel File";
      return false;
    }
    else {
      return true;
    }
  }

  modalClose() {
    this.modalService.dismissAll();
    this.getSparePartsGridDataOnSearch();
    this.enableDisableSavebtn = true;
    this.sparePartsInfo = new spareParts();
     this.partNumberSelectedId = 0;
    this.partNumberSelectedValue = "";
    this.sparePartsInfo = new spareParts();
    this.addPONumber = "";
    this.addBranch = "";
    this.addOrderNumber = "";
    this.txtBranch = "";
    this.txtShipperName = "";
    this.txtShipperPhone = "";
    this.txtBuildingAddress = "";
    this.txtUnitNumber = "";
    this.txtJobSite = "";
    this.txtNotes = "";
    this.partNumbers = [];
    this.partNumberSelectedId = 0;
    this.partNumberSelectedValue = "";
    this.lblErrorBranch = "";
    this.lblErrorShipperName = "";
    this.lblErrorShipperPhone = "";
    this.lblErrorUnitNumber = "";
    this.lblErrorPartNumber = "";
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.excelUnitTypeError = "";
  }

  exportExcel() {
    const dateObj = new Date();
    if (this.PriorityLoadData !== null && this.PriorityLoadData.length > 0) {
      const params = {
        columnGroups: true,
        allColumns: false,
        fileName: "Otis_One_Report-" + dateObj.getFullYear() + '_' + (String(dateObj.getMonth() + 1).padStart(2, '0')) + '_' + String(dateObj.getDate()).padStart(2, '0')
      };
      this.agPGridEdiOrders.api.exportDataAsCsv(params);
    }
    else {
      this.toastr.showError("No Data exists to export");
    }
  }

  open(content) {
    this.modalService.open(content, { windowClass: "mySPCustomModalClass", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    if (content._declarationTContainer.localNames[0] == 'addSparePartsModal') {
      this.getPOOrderDetails();
      this.getPartNumbers();
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onPriorityKeyEnter() {
    this.getFilteredSortedGrid();
  }

  getFilteredSortedGrid() {
    if (this.txtPriEdiOrdersSrch == null || this.txtPriEdiOrdersSrch == "") {
      this.getPriorityGridDataOnSearch();
      if (this.PriorityLoadData.length == 0) {
        this.toastr.showError("No records found");
      }
    }
    else {
      if (this.PriorityLoadData != null) {
        this.PriorityRowData = this.PriorityLoadData.filter(item => item.poNumber.toUpperCase().includes(this.txtPriEdiOrdersSrch.toUpperCase())
          || item.orderNumber.includes(this.txtPriEdiOrdersSrch)
          || item.machine.toUpperCase().includes(this.txtPriEdiOrdersSrch.toUpperCase()));
      }
    }
  }

  btnPrioritySave() {
    if (this.PriorityRowData.length == 0 || this.PriorityRowData == null) {
      this.toastr.showError("No data to save, upload EDI orders data");
    }
    else {
      this.agPGridEdiOrders.api.stopEditing();
      this.UpdatePriorityRowData = this.PriorityRowData.filter(x => x.priority != x.priorityHidden);
      this.apiService
        .updateEDIPriorityData(this.UpdatePriorityRowData)
        .subscribe((updatedCount: any) => {
          this.getPriorityGridDataOnSearch();
          this.toastr.showSuccess("Priority saved Successfully");
        });
    }
  }

  resetPFilters() {
    this.txtPriEdiOrdersSrch = "";
    this.getPriorityGridDataOnSearch();
  }

  resetSPFilters() {
    this.txtSparePartsSrch = "";
    this.partNumberSelectedId = 0;
    this.partNumberSelectedValue = "";
    this.sparePartsInfo = new spareParts();
    this.addPONumber = "";
    this.addBranch = "";
    this.addOrderNumber = "";
    this.txtBranch = "";
    this.txtShipperName = "";
    this.txtShipperPhone = "";
    this.txtBuildingAddress = "";
    this.txtUnitNumber = "";
    this.txtJobSite = "";
    this.txtNotes = "";
    this.partNumbers = [];
    this.partNumberSelectedId = 0;
    this.partNumberSelectedValue = "";
    this.lblErrorBranch = "";
    this.lblErrorShipperName = "";
    this.lblErrorShipperPhone = "";
    this.lblErrorUnitNumber = "";
    this.lblErrorPartNumber = "";
    this.getSparePartsGridDataOnSearch();
  }

  onSparePartsKeyEnter() {
    this.getSparePartsGridDataOnSearch();
  }

  ResetSparePartsFields() {
    this.cpib2GatewaySparePartsdetails = new cpib2GatewaySpareParts;
    this.epalGatewaySparePartsdetails = new epalGatewaySpareParts;
    this.epalDeviceSparePartsdetails = new epalDeviceSpareParts;
    this.txtSparePartsSrch = "";
    this.isRowSelected = false;
    this.rowSelectedData = [];
    this.selectedSPartsInfo = [];
    this.gatewayUpdateEnable = false;
    this.gatewaySimCardEnable = false;
    this.ePALgatewayUpdateEnable = false;
    this.ePALgatewaySimCardEnable = false;
    this.ePALDeviceEnable = false;
    this.unitNumber = "";
    this.shipperName = "";
    this.buildingAddress = "";
    this.gatewayTypeSelectedValue = "DIGI-EX12";
    this.eGatewayTypeSelectedValue = "DIGI-EX12";
    this.txtGWMlMacAdd = "002704";
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.txtGWPwd = "";
    this.lblErrorGWMLMacAdd = "";
    this.lblErrorGWMLType = "";
    this.lblErrorEUUID = "";
    this.lblErrorESerialNumber = "";
    this.lblErrorDevAppType = "";
    this.gatewayTypeSelectedId = 3;
    this.eGatewayTypeSelectedId = 3
    this.txtEGWMlMacAdd = "002704";
    this.txtEGWPwd = "";
    this.txtEGWMlIccId = "";
    this.txtEGWMlIccId2 = "";
    this.appContentSelectedId = 0;
    this.sparePartsInfo = new spareParts();
  }

  getSparePartsGridDataOnSearch() {
    if (this.txtSparePartsSrch.length > 0) {
      this.filteredSparePartsLoadData = this.sparePartsLoadData.filter(item => item.poNumber.toUpperCase().includes(this.txtSparePartsSrch.toUpperCase())
        || item.orderNumber.includes(this.txtSparePartsSrch)
        || item.branch.toUpperCase().includes(this.txtSparePartsSrch.toUpperCase()));
    }
    else {
      this.ResetSparePartsFields();
      this.apiService
        .getSparePartsData()
        .subscribe((data: sparePartsList[]) => {
          if (data != null) {
            this.filteredSparePartsLoadData = this.sparePartsLoadData = data;
          }
          else {
            this.sparePartsLoadData = [];
          }
        });
    }
  }

  sparePartsExportExcel() {
    const dateObj = new Date();
    if (this.sparePartsLoadData !== null && this.sparePartsLoadData.length > 0) {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: "Spare_Parts_Report-" + dateObj.getFullYear() + '_' + (String(dateObj.getMonth() + 1).padStart(2, '0')) + '_' + String(dateObj.getDate()).padStart(2, '0')
      };
      this.agSPGrid.api.exportDataAsCsv(params);
    }
    else {
      this.toastr.showError("No Data exists to export");
    }
  }

  onRowSelected(event) {
    if (event.node.selected) {
      this.selectedSPartsInfo.push(event.node.data);
    }
    else {
      var index = this.selectedSPartsInfo.indexOf(event.node.data);
      if (index >= 0) {
        this.selectedSPartsInfo.splice(index, 1);
      }
    }
    if (this.selectedSPartsInfo.length >= 0) {
      this.isRowSelected = true;
      this.rowSelectedData = this.selectedSPartsInfo;
      this.shipperName = this.rowSelectedData[0].shipperName;
      this.poNumber = this.rowSelectedData[0].poNumber;
      this.orderNumber = this.rowSelectedData[0].orderNumber;
      this.branch = this.rowSelectedData[0].branch;
      this.buildingAddress = this.rowSelectedData[0].buildingAddress;

      if (this.rowSelectedData[0].unitNumber != null && this.rowSelectedData[0].unitNumber != "") {
        this.unitNumber = this.rowSelectedData[0].unitNumber;
      }
      if (this.rowSelectedData[0].gatewayType != null && this.rowSelectedData[0].gatewayType != "") {
        this.gatewayTypeSelectedValue = this.rowSelectedData[0].gatewayType;
        this.gatewayTypeSelectedId = this.gatewayTypes.find(x => x.name === this.gatewayTypeSelectedValue).id;
      }
      if (this.rowSelectedData[0].epalGatewayType != null && this.rowSelectedData[0].epalGatewayType != "") {
        this.eGatewayTypeSelectedValue = this.rowSelectedData[0].epalGatewayType;
        this.eGatewayTypeSelectedId = this.gatewayTypes.find(x => x.name === this.eGatewayTypeSelectedValue).id;
      }
      if (this.rowSelectedData[0].deviceGatewayType != null && this.rowSelectedData[0].deviceGatewayType != "") {
        this.devicegatewayTypeSelValue = this.rowSelectedData[0].deviceGatewayType;
        this.devicegatewayTypeSelId = this.Devicegateway.find(x => x.name === this.devicegatewayTypeSelValue).id;
      }
      if (this.rowSelectedData[0].deviceApplicationType != null && this.rowSelectedData[0].deviceApplicationType != "") {
        this.appContentSelectedValue = this.rowSelectedData[0].deviceApplicationType;
        this.appContentSelectedId = this.appContent.find(x => x.applicationName === this.appContentSelectedValue).contentId;
      }

      if (this.rowSelectedData[0].gatewayMacAddress != null && this.rowSelectedData[0].gatewayMacAddress != "") {
        this.txtGWMlMacAdd = this.rowSelectedData[0].gatewayMacAddress;
      }
      this.txtGWMlIccId = this.rowSelectedData[0].gatewaySimCardICCID1;
      this.txtGWMlIccId2 = this.rowSelectedData[0].gatewaySimCardICCID2;

      if (this.rowSelectedData[0].epalGatewayMacAddress != null && this.rowSelectedData[0].epalGatewayMacAddress != "") {
        this.txtEGWMlMacAdd = this.rowSelectedData[0].epalGatewayMacAddress;
      }
      this.txtEGWMlIccId = this.rowSelectedData[0].epalGatewaySimCardICCID1;
      this.txtEGWMlIccId2 = this.rowSelectedData[0].epalGatewaySimCardICCID2;
      this.txtePalUUID = this.rowSelectedData[0].epalHardwareID;
      this.txteSerailNumber = this.rowSelectedData[0].eloViewSerialNumber;
    }
    else {
      this.isRowSelected = false;
      this.rowSelectedData = {};
    }
  }

  gatewayTypeSelectChanged($event) {
    this.gatewayTypeSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    this.gatewayTypeSelectedValue === "DIGI-WR21" ? this.txtGWMlMacAdd = "00042D" : (this.gatewayTypeSelectedValue === "DIGI-EX12" ? this.txtGWMlMacAdd = "002704" : (this.gatewayTypeSelectedValue === "DIGI-EX15" ? this.txtGWMlMacAdd = "002704" : this.txtGWMlMacAdd = ""));

  }

  egatewayTypeSelectChanged($event) {
    this.eGatewayTypeSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    this.eGatewayTypeSelectedValue === "DIGI-WR21" ? this.txtEGWMlMacAdd = "00042D" : (this.eGatewayTypeSelectedValue === "DIGI-EX12" ? this.txtEGWMlMacAdd = "002704" : (this.eGatewayTypeSelectedValue === "DIGI-EX15" ? this.txtEGWMlMacAdd = "002704" : this.txtEGWMlMacAdd = ""));
  }

  //Get gateway types
  getGatewayTypes() {
    this.masterDataService
      .getGatewayType()
      .subscribe((data: any) => {
        this.gatewayTypes = data.filter(gt => gt.name.includes('DIGI'));
      });
  }

  clearErrorMessages() {
    this.lblErrorGWMLMacAdd = "";
    this.lblErrorEGWMLMacAdd = "";
    this.lblErrorGSimCard = "";
    this.lblErrorEGSimCard = "";
  }

  GatewayMacAddressValidations(): boolean {
    this.txtGWMlMacAdd = this.txtGWMlMacAdd.replace(/\:/g, "").trim();

    if (this.gatewayUpdateEnable && this.txtGWMlMacAdd.length !== 12) {
      this.lblErrorGWMLMacAdd = "Gateway Mac Address should be 12 characters length";
      return false;
    }
    else {
      this.lblErrorGWMLMacAdd = "";
    }
    this.txtEGWMlMacAdd = this.txtEGWMlMacAdd.replace(/\:/g, "").trim();

    if (this.ePALgatewayUpdateEnable && this.txtEGWMlMacAdd.length !== 12) {
      this.lblErrorEGWMLMacAdd = "Gateway Mac Address should be 12 characters length";
      return false;
    }
    else {
      this.lblErrorEGWMLMacAdd = "";
    }
    if (this.gatewaySimCardEnable && (this.txtGWMlIccId == null || this.txtGWMlIccId == "") && (this.txtGWMlIccId2 == null || this.txtGWMlIccId2 == "")) {
      this.lblErrorGSimCard = "Please provide any sim card details";
      return false;
    }
    else {
      this.lblErrorGSimCard = "";
    }
    if (this.ePALgatewaySimCardEnable && (this.txtEGWMlIccId == null || this.txtEGWMlIccId == "") && (this.txtEGWMlIccId2 == null || this.txtEGWMlIccId2 == "")) {
      this.lblErrorEGSimCard = "Please provide any sim card details";
      return false;
    }
    else {
      this.lblErrorEGSimCard = "";
    }
    if (this.ePALDeviceEnable && (this.txtePalUUID == null || this.txtePalUUID == "")) {
      this.lblErrorEUUID = "Please provide UUID";
      return false;
    }
    else {
      this.lblErrorEUUID = "";
    }
    if (this.ePALDeviceEnable && (this.txteSerailNumber == null || this.txteSerailNumber == "")) {
      this.lblErrorESerialNumber = "Please provide Serial Number";
      return false;
    }
    else {
      this.lblErrorESerialNumber = "";
    }
    if (this.ePALDeviceEnable && (this.appContentSelectedId == 0)) {
      this.lblErrorDevAppType = "Please select Application Type";
      return false;
    }
    else {
      this.lblErrorDevAppType = "";
    }
    return true;
  }

  enableDisableSave() {
    this.clearErrorMessages();
    this.enableDisableSavebtn = true;
    if (this.gatewayUpdateEnable || this.gatewaySimCardEnable || this.ePALgatewayUpdateEnable || this.ePALgatewaySimCardEnable || this.ePALDeviceEnable) {
      this.enableDisableSavebtn = false;
    }
  }

  gatewayChange($event: MatSlideToggleChange) {
    this.gatewayUpdateEnable = $event.checked;
    this.enableDisableSave();
  }
  gatewaySimCardChange($event: MatSlideToggleChange) {
    this.gatewaySimCardEnable = $event.checked;
    this.enableDisableSave();
  }

  epalGatewayChange($event: MatSlideToggleChange) {
    this.ePALgatewayUpdateEnable = $event.checked;
    this.enableDisableSave();
  }

  epalSimCardChange($event: MatSlideToggleChange) {
    this.ePALgatewaySimCardEnable = $event.checked;
    this.enableDisableSave();
  }

  epalDeviceChange($event: MatSlideToggleChange) {
    this.ePALDeviceEnable = $event.checked;
    this.enableDisableSave();
  }

  onSaveSpareParts($event) {
    if (this.GatewayMacAddressValidations()) {
      this.sparePartsInfo.PoNumber = this.poNumber;
      this.sparePartsInfo.UnitNumber = this.unitNumber;

      if ((this.gatewayUpdateEnable || this.gatewaySimCardEnable) && this.txtGWMlMacAdd.length > 6) {
        this.sparePartsInfo.SaveCpib2 = true;
        this.cpib2GatewaySparePartsdetails.gatewayMacAddress = this.txtGWMlMacAdd;
        this.cpib2GatewaySparePartsdetails.gatewayType = this.gatewayTypeSelectedValue;
        this.cpib2GatewaySparePartsdetails.password = this.txtGWPwd;
      }

      if ((this.gatewaySimCardEnable || this.gatewayUpdateEnable) && (this.txtGWMlIccId != null || this.txtGWMlIccId2 != null)) {
        this.sparePartsInfo.SaveCpib2Sim = true;
        this.cpib2GatewaySparePartsdetails.simCardIccId1 = this.txtGWMlIccId;
        this.cpib2GatewaySparePartsdetails.simCardIccId2 = this.txtGWMlIccId2;
      }

      if ((this.ePALgatewayUpdateEnable || this.ePALgatewaySimCardEnable) && this.txtEGWMlMacAdd.length > 6) {
        this.sparePartsInfo.SaveEpalGateway = true;
        this.epalGatewaySparePartsdetails.gatewayMacAddress = this.txtEGWMlMacAdd;
        this.epalGatewaySparePartsdetails.gatewayType = this.eGatewayTypeSelectedValue;
        this.epalGatewaySparePartsdetails.deviceGatewayTypeId = this.devicegatewayTypeSelId;
        this.epalGatewaySparePartsdetails.password = this.txtEGWPwd;
      }

      if ((this.ePALgatewaySimCardEnable || this.ePALgatewayUpdateEnable) && (this.txtEGWMlIccId != null || this.txtEGWMlIccId2 != null)) {
        this.sparePartsInfo.SaveEpalGatewaySim = true;
        this.epalGatewaySparePartsdetails.simCardIccId = this.txtEGWMlIccId;
        this.epalGatewaySparePartsdetails.simCardIccId2 = this.txtEGWMlIccId2;
      }

      if (this.ePALDeviceEnable) {
        this.sparePartsInfo.SaveEpalDevice = true;
        this.epalDeviceSparePartsdetails.eloViewSerialNumber = this.txteSerailNumber;
        this.epalDeviceSparePartsdetails.deviceApplicationType = this.appContentSelectedValue;
        this.epalDeviceSparePartsdetails.epalHardwareId = this.txtePalUUID;
      }

      this.sparePartsInfo.CPIB2GatewaySparePartsdetails = this.cpib2GatewaySparePartsdetails;
      this.sparePartsInfo.EpalGatewaySparePartsdetails = this.epalGatewaySparePartsdetails;
      this.sparePartsInfo.EpalDeviceSparePartsdetails = this.epalDeviceSparePartsdetails;

      this.apiService
        .saveUpdateSpareParts(this.sparePartsInfo)
        .subscribe((data: any) => {
          if (data) {
            this.toastr.showSuccess("Spare Parts details saved Successfully");
            this.modalService.dismissAll();
            this.ResetSparePartsFields();
            this.getSparePartsGridDataOnSearch();
          }
        });
    }
  }

  getDeviceGatewayTypes() {
    this.masterDataService
      .getDeviceGateway()
      .subscribe((data: any) => {
        this.Devicegateway = data.slice(1);
      });
  }

  onContentSelectChanged($event) {
    this.appContentSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    this.appContentSelectedId = $event.target.value;

    if (this.appContentSelectedValue !== "--- Select ---") {
      this.appContentError = "";
    }
  }

  getEloViewAppContent() {
    this.apiService
      .getEloViewAppContent()
      .subscribe((data: any) => {
        this.appContent = data;
      });
  }

  getPOOrderDetails() {
    this.apiService
      .getPOOrderDetails()
      .subscribe((ediOrder: ediorder) => {
        if (ediOrder != null) {
          this.addPONumber = ediOrder.poNumber;
          this.addOrderNumber = ediOrder.orderNumber;
        }
      });
  }

  getPartNumbers() {
    this.apiService
      .getEDIPartNumbers()
      .subscribe((data: any) => {
        this.partNumbers = data;
      });
  }

  partNumberChanged($event) {
    this.partNumberSelectedId = $event.target.selectedIndex;
    this.partNumberSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    if (this.partNumberSelectedId !== 0) {
      this.lblErrorPartNumber = "";
    }
  }

  onAddSpareParts(event) {
    if (this.txtBranch === null || this.txtBranch === undefined || this.txtBranch.trim() === "") {
      this.lblErrorShipperPhone = "";
      this.lblErrorShipperName = "";
      this.lblErrorUnitNumber = "";
      this.lblErrorPartNumber = "";
      this.lblErrorBranch = "Enter Branch"
    }
    else if (this.txtShipperName === null || this.txtShipperName === undefined || this.txtShipperName.trim() === "") {
      this.lblErrorBranch = "";
      this.lblErrorShipperPhone = "";
      this.lblErrorUnitNumber = "";
      this.lblErrorPartNumber = "";
      this.lblErrorShipperName = "Enter Shipper Name"
    }
    else if (this.txtShipperPhone === null || this.txtShipperPhone === undefined || this.txtShipperPhone.trim() === "") {
      this.lblErrorBranch = "";
      this.lblErrorShipperName = "";
      this.lblErrorUnitNumber = "";
      this.lblErrorPartNumber = "";
      this.lblErrorShipperPhone = "Enter Shipper Phone"
    }
    else if (this.txtUnitNumber === null || this.txtUnitNumber === undefined || this.txtUnitNumber.trim() === "") {
      this.lblErrorBranch = "";
      this.lblErrorShipperName = "";
      this.lblErrorShipperPhone = "";
      this.lblErrorPartNumber = "";
      this.lblErrorUnitNumber = "Enter Unit Number"
    }
    else if (this.partNumberSelectedId == 0) {
      this.lblErrorBranch = "";
      this.lblErrorShipperName = "";
      this.lblErrorShipperPhone = "";
      this.lblErrorUnitNumber = "";
      this.lblErrorPartNumber = "Please select Part Number";
    }
    else {
      this.lblErrorBranch = "";
      this.lblErrorShipperName = "";
      this.lblErrorShipperPhone = "";
      this.lblErrorUnitNumber = "";
      this.lblErrorPartNumber = "";
      this.ediOrder.poNumber = this.addPONumber;
      this.ediOrder.orderNumber = this.addOrderNumber;
      this.ediOrder.contract = this.addOrderNumber;
      this.ediOrder.branch = this.txtBranch;
      this.ediOrder.shipperName = this.txtShipperName;
      this.ediOrder.shipperPhone = this.txtShipperPhone;
      this.ediOrder.buildingAddress = this.txtBuildingAddress;
      this.ediOrder.unitNumber = this.txtUnitNumber;
      this.ediOrder.partNumber = this.partNumberSelectedValue;
      this.ediOrder.jobSite = this.txtJobSite;
      this.ediOrder.notes = this.txtNotes;
      this.apiService
        .addSparePart(this.ediOrder)
        .subscribe((data: any) => {
          if (data == true) {
            this.toastr.showSuccess("Successfully added Spare Part !!");
            this.modalClose();
          }
          else {
            this.toastr.showError("Adding Spare Part is Failed !!");
          }
        });
    }
  }
  getLoggedInUserDetails()
  {
    let claims = this.oauthService.getIdentityClaims();
    if (claims !== null && claims !== undefined) { 
      this.apiService
        .getUserDetails(claims["oid"])
        .subscribe({
          next: (data: any) => {
            if (data != null) {
              this.userDetails = data;
              this.enableEDIOrder = this.userDetails["enableEDIOrder"];
              if(this.userDetails["enableEDIOrder"] == false)
              {
                this.router.navigate(['/home']);
              }
            }
          },
          error: () => {
          }
        });     
    }
  }

}
